<template>
  <v-badge color="transparent" avatar overlap>
    <template v-slot:badge>
      <v-btn
        v-if="media.length"
        @click="deleteUserAvatar()"
        text
        icon
        color="error"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>

    <v-avatar size="150px">
      <v-img v-if="media.length" @click="handleAvatarClick()" :src="image" />
      <div v-else>
        <v-icon size="150px" @click="handleAvatarClick()">
          mdi-image-plus
        </v-icon>
      </div>
      <input
        class="d-none"
        ref="fileInput"
        type="file"
        accept="image/*"
        @input="handleFileInput()"
      />
    </v-avatar>
  </v-badge>
</template>

<script>
import MediaMixin from "@/mixins/Media/MediaMixin";
export default {
  mixins: [MediaMixin],

  props: {
    uploadUrl: {},
    params: {},
    media: {},
  },

  data: () => ({
    image: null,

    form: {
      image: null,
    },
  }),

  computed: {
    mediaData() {
      return this.media[0];
    },
    avatarPath() {
      return this.getImage(this.mediaData);
    },
  },

  watch: {
    avatarPath(val) {
      this.image = val;
    },
  },

  created() {
    this.image = this.avatarPath;
  },

  methods: {
    deleteUserAvatar() {
      this.$loading.start();

      this.$http
        .destroy(this.uploadUrl, this.mediaData.id, this.params)

        .then((response) => {
          this.$emit("store");
          this.$loading.finish();
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },
    handleAvatarClick() {
      this.$refs.fileInput.click();
    },

    handleFileInput() {
      let input = this.$refs.fileInput;
      let files = input.files;

      if (files && files[0]) {
        let reader = new FileReader();

        reader.onload = (e) => {
          this.image = e.target.result;
          this.form.image = files[0];
          this.storeMedia();
        };

        reader.readAsDataURL(files[0]);
      }
    },

    getFormData() {
      let form = new FormData();
      form.append("image", this.form.image);

      if (this.params) {
        for (let key in this.params) {
          form.append(key, this.params[key]);
        }
      }
      return form;
    },

    async storeMedia() {
      this.$loading.start();

      await this.$http
        .$post(`${this.uploadUrl}`, this.getFormData())
        .then((response) => {
          this.$emit("store");
          this.$loading.finish();
        })
        .catch((erro) => {
          this.$loading.finish();
        });
    },
  },
};
</script>

<style></style>
